// extracted by mini-css-extract-plugin
module.exports = {"about3box":"About3_about3box__Mco8F","sec2":"About3_sec2__3ssdD","slidediv":"About3_slidediv__3PNpF","swiperc":"About3_swiperc__JZapG","slide":"About3_slide__2ve6Y"};